/* eslint-disable */
import React, { PropTypes } from 'react'
import { Table, Column, Cell } from 'fixed-data-table';
import _ from 'lodash';
import $ from 'jquery';
import { browserHistory } from 'react-router';
import { DataListWrapper } from "../../../commonComponents/DataTable/DataTablePs";
// import { DataListWrapper, SortTypes, SortHeaderCell, TextCell, NewsTypeCell, TimeWithoutHHmmssCell } from "../../../commonComponents/DataTable/DataTablePs";
// import custJqAjax from '../../../commonJS/custJqAjax';

export default class AdminRoleDataTableCt extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      is_loading: true,
      all_data: [],
      main_role_name_sort: 'asc',
      role_name_sort: 'asc',
      department_name_sort: 'asc',
      usergroup_data: [],
      is_loaded_all_data: false,
      is_loaded_usergroup_data: false,
      is_reloading: false,
      width: 900
    }

    this.loadData = this.loadData.bind(this);
    this.reloadData = this.reloadData.bind(this);
  }

  componentDidMount() {

    this.loadData();
    this.setState({ width: document.getElementById('system_maintain').offsetWidth })
  }

  componentWillReceiveProps(nextProps) {

    const { main_role_name_sort } = this.state
    let sort_data = []

    if (nextProps.searchResults._data) {

      if (this.props.searchResults._data !== nextProps.searchResults._data) {

        sort_data = _.orderBy(nextProps.searchResults._data, ['main_role_name'], [main_role_name_sort])
      }
    }
    else if (nextProps.searchResults._data === undefined) {

      sort_data = _.orderBy(nextProps.filteredDataList._data, ['main_role_name'], [main_role_name_sort])
    }

    this.setState({ all_data: sort_data })
  }

  componentDidUpdate(prevProps, prevState) {

    const { is_loaded_all_data, is_loaded_usergroup_data, is_loading, all_data, usergroup_data, is_reloading } = this.state

    if ((is_loaded_all_data === true && is_loaded_usergroup_data === true && is_loading === true) || is_reloading === true) {

      let merge_data = all_data.map((x, y) => {

        let find_data1 = _.find(all_data, { sub_role: x.main_role })
        x.main_role_name = find_data1 !== undefined ? find_data1.role_name : '無'

        let find_data2 = _.find(usergroup_data, { id: x.department_id })
        x.department_name = find_data2 !== undefined ? find_data2.name : '無'

        return x;
      })

      let defaultSortIndexes = [];
      let size = merge_data.length;
      for (let i = 0; i < size; i++) {
        defaultSortIndexes.push(i);
      }
      this.props.returnDataListToDashboardFunc(new DataListWrapper(defaultSortIndexes, merge_data), 'Role');
      this.setState({ all_data: merge_data, is_loading: false, is_reloading: false })
    }
  }

  loadData() {

    $.ajax({
      type: 'get',
      url: '/api/W_Role_Get.php',
      success: response => {
        this.setState({ all_data: response.result, is_loaded_all_data: true });
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    });

    $.ajax({
      type: 'get',
      url: '/api/W_UserGroup_Get.php',
      success: response => {
        this.setState({ usergroup_data: response.result, is_loaded_usergroup_data: true });
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    });
  }

  reloadData() {

    $.ajax({
      type: 'get',
      url: '/api/W_Role_Get.php',
      success: response => {
        this.setState({ all_data: response.result, is_reloading: true });
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    });
  }

  onRowClick(row) {
    browserHistory.push('/salesky/admin/Role/' + row.sub_role);
  }

  onSortChange(value, sort, sort_name) {

    const { all_data } = this.state

    let new_sort = sort === 'asc' ? 'desc' : 'asc'
    let sort_data = _.orderBy(all_data, [value], [new_sort])
    let new_state = {}
    new_state['all_data'] = sort_data
    new_state[sort_name] = new_sort
    this.setState(new_state)
  }

  render() {
    const { closeModal, tableHeight } = this.props
    const { is_loading, all_data, main_role_name_sort, role_name_sort, department_name_sort, width } = this.state
    const loading = is_loading === true ? <div className="loading" style={{ maxWidth: '900px' }}><img role="presentation" src="/imgs/loading.gif" /></div> : false

    let modal = this.props.children ? React.cloneElement(this.props.children, {
      closeModal: closeModal,
      // category: category.name,
      reloadData: this.reloadData,
      // rowItem: this.state.rowItem
    }) : "";

    return (
      <div id="system_maintain" style={{ position: "relative" }}>
        {loading}
        <Table
          rowHeight={50}
          headerHeight={50}
          rowsCount={all_data.length}
          width={width}
          height={tableHeight || 477}
          onRowClick={(event, rowIndex) => this.onRowClick(all_data[rowIndex])} //onRowClick自帶三個props: event, rowIndex, Object
        // {...this.props}
        >
          <Column
            width={300}
            flexGrow={1}
            cell={({ rowIndex, ...props }) => (
              <Cell {...props}>
                {all_data[rowIndex]['main_role_name']}
              </Cell>
            )}
            header={
              <Cell>
                <a onClick={() => this.onSortChange('main_role_name', main_role_name_sort, 'main_role_name_sort')}
                  style={{ textDecoration: "none", cursor: "pointer" }}>
                  父階角色 {role_name_sort === 'asc' ? '↓' : '↑'}
                </a>
              </Cell>
            }
          />
          <Column
            width={300}
            flexGrow={1}
            cell={({ rowIndex, ...props }) => (
              <Cell {...props}>
                {all_data[rowIndex]['role_name']}
              </Cell>
            )}
            header={
              <Cell>
                <a onClick={() => this.onSortChange('role_name', role_name_sort, 'role_name_sort')}
                  style={{ textDecoration: "none", cursor: "pointer" }}>
                  角色名稱 {role_name_sort === 'asc' ? '↓' : '↑'}
                </a>
              </Cell>
            }
          />
          <Column
            width={300}
            flexGrow={1}
            cell={({ rowIndex, ...props }) => (
              <Cell {...props}>
                {all_data[rowIndex]['department_name']}
              </Cell>
            )}
            header={
              <Cell>
                <a onClick={() => this.onSortChange('department_name', department_name_sort, 'department_name_sort')}
                  style={{ textDecoration: "none", cursor: "pointer" }}>
                  部門名稱 {role_name_sort === 'asc' ? '↓' : '↑'}
                </a>
              </Cell>
            }
          />
        </Table>
        {modal}
      </div>
    )
  }
}

AdminRoleDataTableCt.PropTypes = {
  filteredDataList: PropTypes.object.isRequired,
}





// WEBPACK FOOTER //
// ./src/salesky/routes/admin/AdminRoleDataTable.jsx